
import { Product } from "@/lib/types";
import StatsSummary from "@/components/dashboard/StatsSummary";

interface StatsSectionProps {
  products: Product[];
  lowStockProducts: Product[];
}

const StatsSection = ({ products, lowStockProducts }: StatsSectionProps) => {
  return (
    <StatsSummary 
      products={products}
      lowStockProducts={lowStockProducts}
    />
  );
};

export default StatsSection;
